<template>
  <div>
    <template v-if="formGroups && formGroups.length">
      <div
        v-for="(formGroupItem, formGroupIndex) in formGroups"
        :key="formGroupIndex"
        class="form-group">
        <ul
          v-for="(groupItem, groupItemIndex) in formGroupItem"
          :key="groupItemIndex"
          class="form-group__items">
          <li
            class="form-group__item">
            <b
              class="form-group__item-key">{{ groupItem.key }}</b> - {{ groupItem.value }}
          </li>
        </ul>
      </div>
    </template>
    <template v-else>
      -
    </template>
  </div>
</template>
<script>
import organizerSettings from 'mixins/organizerSettings'

export default {
  name: 'settingFormioView',
  mixins: [organizerSettings],
  computed: {
    formGroups() {
      if (!this.value) {
        return []
      }
      return this.$_getViewFormValue(this.value)
    }
  },
  props: {
    value: {
      type: String
    }
  },
}
</script>
<style scoped lang="scss">
.form-group {
  border-top: 1px solid var(--color-main-green);
  &:nth-child(1) {
    border-top-color: transparent;
  }
}
</style>
